module.exports = __webpack_public_path__ + "static/Inter-Regular-1e081edc16d92d42aeccec760174fbf4.woff2";